/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Occupation_ActiveInputs */

const en_us2_occupation_active = /** @type {(inputs: Occupation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walking, carrying`)
};

const pt_br2_occupation_active = /** @type {(inputs: Occupation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andando, carregando`)
};

const es_419_occupation_active = /** @type {(inputs: Occupation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caminando, cargando cosas`)
};

const pt_pt2_occupation_active = /** @type {(inputs: Occupation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A andar, a carregar coisas`)
};

const fr_fr2_occupation_active = /** @type {(inputs: Occupation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En mouvement, à porter des charges`)
};

const de_de2_occupation_active = /** @type {(inputs: Occupation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehen, Tragen`)
};

const it_it2_occupation_active = /** @type {(inputs: Occupation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cammino, trasporto cose`)
};

/**
* | output |
* | --- |
* | "Walking, carrying" |
*
* @param {Occupation_ActiveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const occupation_active = /** @type {((inputs?: Occupation_ActiveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Occupation_ActiveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_occupation_active(inputs)
	if (locale === "es-419") return es_419_occupation_active(inputs)
	if (locale === "pt-PT") return pt_pt2_occupation_active(inputs)
	if (locale === "fr-FR") return fr_fr2_occupation_active(inputs)
	if (locale === "de-DE") return de_de2_occupation_active(inputs)
	if (locale === "it-IT") return it_it2_occupation_active(inputs)
	return en_us2_occupation_active(inputs)
});
export { occupation_active as "occupation.active" }